import { render, staticRenderFns } from "./FeedingActionList.vue?vue&type=template&id=b2f03728&scoped=true&"
import script from "./FeedingActionList.vue?vue&type=script&lang=js&"
export * from "./FeedingActionList.vue?vue&type=script&lang=js&"
import style0 from "./FeedingActionList.vue?vue&type=style&index=0&id=b2f03728&lang=scss&scoped=true&"
import style1 from "./FeedingActionList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f03728",
  null
  
)

export default component.exports